import GeneralReportIcon from "../images/GeneralReportIcon"
import GeneralReportIconActive from "../images/GeneralReportIconActive"
import ItemMovementReportIcon from "../images/ItemMovementReportIcon"
import ItemMovementReportIconActive from "../images/ItemMovementReportIconActive"
import FinancialReports from "../page/FinancialReports/FinancialReports"
import GeneralReport from "../page/Report/GeneralReport"
import ItemMovementReport from "../page/Report/ItemMovementReport"
import TableReservations from "../page/TableReservations/TableReservations"
import TableReservationsCreate from "../page/TableReservations/TableReservationsCreate"
import TableReservationsDetail from "../page/TableReservations/TableReservationsDetail"

const ReportSideBar = [
    {
        index: 1,
        name: "GL Report",
        show: true,
        showRoute: true,
        path: "/generalReport",
        component: GeneralReport,
        image: GeneralReportIcon,
        imageActive: GeneralReportIconActive
    },
    {
        index: 2,
        name: "Item Movement",
        show: true,
        showRoute: true,
        path: "/itemMovement",
        component: ItemMovementReport,
        image: ItemMovementReportIcon,
        imageActive: ItemMovementReportIconActive
    },
    {
        index: 3,
        name: "Financial Reports",
        show: true,
        showRoute: true,
        path: "/financialReports",
        component: FinancialReports,
        image: ItemMovementReportIcon,
        imageActive: ItemMovementReportIconActive
    },
    // Table Reservations: list + create + detail are registered as separate
    // routes, mirroring the convention used by other detail-page modules
    // (e.g. JournalEntries). The list entry feeds the sidebar; the create +
    // detail entries have `show: false` so they don't double-render in the
    // sidebar.
    //
    // Route ordering matters: `/tableReservations/create` MUST come BEFORE
    // `/tableReservations/:id`, otherwise React Router matches "create" as
    // an `:id` parameter and the create page is unreachable. Reservation
    // IDs are UUIDs, so there's no real-world clash with the "create"
    // literal — the order is purely a routing-table concern.
    {
        index: 4,
        name: "Table Reservations",
        show: false,
        showRoute: true,
        path: "/tableReservations",
        component: TableReservations,
        image: ItemMovementReportIcon,
        imageActive: ItemMovementReportIconActive
    },
    {
        index: 5,
        name: "Table Reservations",
        show: false,
        showRoute: true,
        path: "/tableReservations/create",
        component: TableReservationsCreate,
        image: ItemMovementReportIcon,
        imageActive: ItemMovementReportIconActive
    },
    {
        index: 6,
        name: "Table Reservations",
        show: false,
        showRoute: true,
        path: "/tableReservations/:id",
        component: TableReservationsDetail,
        image: ItemMovementReportIcon,
        imageActive: ItemMovementReportIconActive
    },
]

export default ReportSideBar